








































import { PaginationPageProps } from '@/models/pagination-page-props';
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { EntityStatus } from '@/api';

@Component({
	computed: {
		EntityStatus() {
			return EntityStatus;
		},
	},
})
export default class EntityPagination<T> extends Vue {
	@PropSync('page')
	public currentPage!: number;

	@Prop({ required: true, type: Array, default: [] })
	public readonly entities!: T[];

	@Prop({ required: true, type: Function })
	public entityTextBuilder!: (entity: T) => string;

	@Prop({ required: true, type: Function })
	public badgeColorBuilder!: (entity: T) => string;

	@Prop({ required: true, type: Function })
	public badgeTextBuilder!: (entity: T) => string;

	@Prop({ required: false, type: Function, default: (_index: number) => {} })
	private onTabClicked!: (tabIndex: number) => void;

	public paginationText(paginationProps: PaginationPageProps): string {
		const index: number = paginationProps.index;
		if (index === 0) {
			return 'Overview';
		}
		return this.entityTextBuilder(this.entities[index - 1]);
	}

	public badgeColor(paginationProps: PaginationPageProps): string {
		const entity: T = this.entities[paginationProps.index - 1];
		return this.badgeColorBuilder(entity);
	}

	public badgeText(paginationProps: PaginationPageProps): string {
		const entity: T = this.entities[paginationProps.index - 1];
		return this.badgeTextBuilder(entity);
	}

	public onClick(index: number) {
		this.onTabClicked(index);
	}
}
